import { FC } from 'react'
import styled from 'styled-components'

import notFoundUrl from '../public/404.png'

import { AlignWrapper } from './AlignWrapper'

/**
 * 404 界面
 *
 * @returns 404 page
 */
export const NotFound: FC = () => {
  return (
    <AlignWrapper>
      <StyledImage src={notFoundUrl} />
    </AlignWrapper>
  )
}

const StyledImage = styled.img`
  width: 600px;
  height: 450px;
`
